import React, { createContext, useContext, useState } from "react";

interface ModalContextType {
  isSplitTicketModalOpen: boolean;
  setIsSplitTicketModalOpen: (isOpen: boolean) => void;
}

const ModalContext = createContext<ModalContextType>({
  isSplitTicketModalOpen: false,
  setIsSplitTicketModalOpen: () => {},
});

export const useModalContext = () => useContext(ModalContext);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isSplitTicketModalOpen, setIsSplitTicketModalOpen] = useState(false);

  return (
    <ModalContext.Provider
      value={{
        isSplitTicketModalOpen,
        setIsSplitTicketModalOpen,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContext;
